import { render, staticRenderFns } from "./analysisReportAdvisor.vue?vue&type=template&id=5fd19343&scoped=true"
import script from "./analysisReportAdvisor.vue?vue&type=script&lang=js"
export * from "./analysisReportAdvisor.vue?vue&type=script&lang=js"
import style0 from "./analysisReportAdvisor.vue?vue&type=style&index=0&id=5fd19343&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd19343",
  null
  
)

export default component.exports